import React, { useState, useEffect, useRef } from 'react';
import Typewriter from 'typewriter-effect';
import bgImg2 from './../../images/bg_3.webp';

const ClinicalFacts = () => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after it becomes visible
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (observer && observer.disconnect) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div
      className="bg-cover bg-no-repeat bg-center w-full h-80 relative flex items-center justify-center"
      style={{
        backgroundImage: `url(${bgImg2})`,
      }}
      ref={elementRef}
    >
      <div className="opacity-80 absolute bg-black w-full h-80"></div>
      <div className="relative z-10 text-center text-white">
        <div className="text-2xl lg:text-5xl">
          {isVisible && (
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .typeString('Wenn Ihr Lächeln nicht zu Ihnen passt... ')
                  .pauseFor(1000) // Pause before starting the next part
                  .typeString('<span class="text-primary">dann kommen Sie zu uns!</span>')
                  .pauseFor(4000) // Wait for 4 seconds before starting to delete
                  .deleteAll()
                  .start();
              }}
              options={{
                autoStart: true,
                loop: true,
                delay: 50, // Adjusted typing speed
                deleteSpeed: 40,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ClinicalFacts;
